import PropTypes from 'prop-types';

import CardModule from '../../shared/card-module';
import { className } from '../../../../utils/GlobalCssProxy';

const IncomeWithdrawalOptions = ({ text, type, typeAbbreviated }) => {
  return (
    <CardModule
      data-analytics-componenttype="half-width-component"
      data-analytics-id="HW_IncomeWithdrawalOptions"
      data-analytics-section="component"
    >
      <CardModule.Header>Income/Withdrawal Options</CardModule.Header>
      <CardModule.Body>
        <p {...className('paragraph-emphasized')}>
          {typeAbbreviated} {type && `- ${type}`}
        </p>
        {text.map((paragraph, index) => {
          return (
            <p
              {...className('paragraph-standard')}
              data-key={`${(paragraph || '').slice(0, 32)}-${index}`}
              key={`${(paragraph || '').slice(0, 32)}-${index}`}
            >
              {paragraph}
            </p>
          );
        })}
      </CardModule.Body>
    </CardModule>
  );
};

IncomeWithdrawalOptions.defaultProps = {
  text: []
};

IncomeWithdrawalOptions.propTypes = {
  text: PropTypes.arrayOf(PropTypes.string),
  type: PropTypes.string,
  typeAbbreviated: PropTypes.string
};

export default IncomeWithdrawalOptions;
